import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { GoogleLogo } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleSignIn() {
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

function formatDetail(detail) {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Welcome to AL-AXE");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatDetail(err?.response?.data?.detail) || "Sign-up failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl border border-slate-200/70 p-8" data-testid="register-form">
        <div className="flex items-center gap-2 mb-6">
          <img src="/al-axe-mark.svg" alt="" aria-hidden="true" className="h-9 w-auto" />
          <div className="font-semibold text-lg tracking-tight">AL-AXE</div>
        </div>
        <h2 className="text-3xl font-semibold tracking-tight">Create an account</h2>
        <p className="text-slate-500 text-sm mt-1 mb-6">Start capturing your operations.</p>

        <button type="button" onClick={startGoogleSignIn} data-testid="google-signin" className="w-full inline-flex items-center justify-center gap-2 border border-slate-200 rounded-full py-3 font-medium text-slate-700 hover:bg-slate-50 mb-4">
          <GoogleLogo size={18} weight="bold"/> Continue with Google
        </button>
        <div className="flex items-center gap-3 my-4 text-xs uppercase tracking-widest text-slate-400">
          <div className="flex-1 h-px bg-slate-200"/> or <div className="flex-1 h-px bg-slate-200"/>
        </div>

        <label className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Name</label>
        <input data-testid="reg-name" value={name} onChange={(e)=>setName(e.target.value)} type="text" autoComplete="name" className="mt-1 mb-4 w-full rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-400" />

        <label className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Email</label>
        <input data-testid="reg-email" value={email} onChange={(e)=>setEmail(e.target.value)} required type="email" autoComplete="email" className="mt-1 mb-4 w-full rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-400" />

        <label className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Password</label>
        <input data-testid="reg-password" value={password} onChange={(e)=>setPassword(e.target.value)} required minLength={8} type="password" autoComplete="new-password" className="mt-1 w-full rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-400" />
        <p className="text-xs text-slate-400 mt-1.5">Min 8 characters · at least 1 letter + 1 number</p>

        <button data-testid="reg-submit" disabled={busy} className="mt-6 w-full al-gradient text-white font-medium py-3 rounded-full disabled:opacity-60 active:scale-[0.98]">
          {busy ? "Creating…" : "Create account →"}
        </button>

        <div className="mt-6 text-sm text-slate-500 text-center">
          Already have an account? <Link to="/login" data-testid="link-login" className="text-slate-900 font-medium hover:underline">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
